import type { Unit } from "../api/types";

export const CM_PER_IN = 2.54;

export function cmToFtIn(cm: number): { ft: number; inch: number } {
  const totalIn = Math.round(cm / CM_PER_IN);
  return { ft: Math.floor(totalIn / 12), inch: totalIn % 12 };
}

export function ftInToCm(ft: number, inch: number): number {
  return Math.round((ft * 12 + inch) * CM_PER_IN * 10) / 10;
}

export function formatHeight(cm: number | null | undefined, unit: Unit): string {
  if (cm == null || !isFinite(cm) || cm <= 0) return "Not set";
  if (unit === "cm") return `${Math.round(cm)} cm`;
  const { ft, inch } = cmToFtIn(cm);
  return `${ft}′ ${inch}″`;
}

/** Parse what someone typed into the height fields. Returns null when it isn't a plausible adult/teen height. */
export function parseHeight(unit: Unit, a: string, b = ""): number | null {
  const num = (s: string) => (s.trim() === "" ? 0 : Number(s.replace(",", ".")));
  let cm: number;
  if (unit === "cm") {
    if (a.trim() === "") return null;
    cm = num(a);
  } else {
    const ft = num(a);
    const inch = num(b);
    if (a.trim() === "" && b.trim() === "") return null;
    if (!isFinite(ft) || !isFinite(inch) || inch < 0 || inch >= 12) return null;
    cm = ftInToCm(ft, inch);
  }
  if (!isFinite(cm) || cm < 120 || cm > 230) return null;
  return Math.round(cm * 10) / 10;
}
